export default __webpack_public_path__ + "static/media/no-apps-img.13c278d4.png";